"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _styles = require("@mui/material/styles");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var Theme = exports["default"] = /*#__PURE__*/function () {
  function Theme(muiTheme) {
    _classCallCheck(this, Theme);
    this.muiTheme = muiTheme;
    this.breakpoints = muiTheme.breakpoints;
  }
  return _createClass(Theme, [{
    key: "isBreakpointDown",
    value: function isBreakpointDown(breakpoint) {
      return window.matchMedia(this.muiTheme.breakpoints.down(breakpoint).replace("@media ", "")).matches;
    }
  }, {
    key: "isBreakpointUp",
    value: function isBreakpointUp(breakpoint) {
      return window.matchMedia(this.muiTheme.breakpoints.up(breakpoint).replace("@media ", "")).matches;
    }
  }, {
    key: "getCurrentBreakpoint",
    value: function getCurrentBreakpoint() {
      var deviceWidth = window.innerWidth;
      var currentBreakpoint = null;
      Object.entries(this.breakpoints.values).forEach(function (b) {
        if (deviceWidth >= b[1]) currentBreakpoint = b;
      });
      return currentBreakpoint;
    }
  }], [{
    key: "getStyleVar",
    value: function getStyleVar(varName) {
      return Theme.computedStyle.getPropertyValue(varName).trim();
    }
  }, {
    key: "createTheme",
    value: function createTheme() {
      return new Theme((0, _styles.createTheme)({
        name: "v2",
        palette: {
          primary: {
            light: "#0000FF",
            main: Theme.getStyleVar("--neon-blue-nb-400"),
            dark: "#000000"
          },
          secondary: {
            light: "#ff0000",
            main: Theme.getStyleVar("--neon-blue-nb-400"),
            dark: "#ff0000"
          },
          error: {
            main: Theme.getStyleVar("--torch-red-tr-500")
          }
        },
        breakpoints: {
          values: {
            xs: 0,
            sm: 600,
            md: 900,
            lg: 1200,
            xl: 1920
          }
        }
      }));
    }
  }]);
}();
_defineProperty(Theme, "computedStyle", getComputedStyle(document.documentElement));